import { Component, OnInit } from "@angular/core";
@Component({
  selector: "gh-example-buttons-component",
  templateUrl: "./example-buttons.component.html",
  styleUrls: [],
})
export class ExampleButtonsComponent implements OnInit {
  ngOnInit(): void {
    // This is not empty!
  }

  public disabledClick(): void {
    // It is absolutely imposible to click!
  }

  public loadingClick(): void {
    // It is absolutely imposible to click!
  }

  public enabledClick(): void {
    // Put some logic to execute on click ;)
  }
}
